import BigNumber from 'bignumber.js';

export const calculateClaimableAmountWei = (
    startTime,
    intervalSeconds,
    claimedMilestones,
    totalPayment,
    totalMilestones,
) => {
    try {
        const start = new BigNumber(startTime.toString());
        const intv = new BigNumber(intervalSeconds.toString());
        const claimed = new BigNumber(claimedMilestones.toString());
        const total = new BigNumber(totalPayment.toString()).multipliedBy(
            new BigNumber(10).pow(18),
        );
        const ms = new BigNumber(totalMilestones.toString());
        if (ms.isZero()) return '0';

        const now = new BigNumber(Math.floor(Date.now() / 1000));
        const lastTs = start.plus(intv.multipliedBy(ms));
        const effectiveTs = BigNumber.minimum(now, lastTs);
        const available = effectiveTs.minus(start).dividedToIntegerBy(intv);
        const claimable = available.minus(claimed);
        if (!claimable.isGreaterThan(0)) return '0';
        return claimable
            .multipliedBy(total.dividedBy(ms))
            .dividedBy(new BigNumber(10).pow(18))
            .toFixed(0);
    } catch (_e) {
        return '0';
    }
};

export const isLockedPaymentFinished = (paymentData) =>
    Boolean(paymentData?.claimed ?? paymentData?.finalized);

export const isLockedPaymentDisputed = (paymentData) =>
    Boolean(paymentData?.isDisputeRaised ?? paymentData?.disputeRaised);

export const getClaimedAmountWei = (
    claimedMilestones,
    totalPayment,
    totalMilestones,
) => {
    try {
        const claimed = new BigNumber(claimedMilestones.toString());
        const total = new BigNumber(totalPayment.toString());
        const ms = new BigNumber(totalMilestones.toString());
        if (ms.isZero()) return '0';
        const perMs = total.dividedBy(ms);
        return claimed.multipliedBy(perMs).toFixed(0);
    } catch (_e) {
        return '0';
    }
};

/** Mirrors LibCronPayMilestones.computeCustomClaimable for UI previews. */
export const computeCustomClaimableWei = (
    scheduleSlots = [],
    claimedMilestones = 0,
    nowSec = Math.floor(Date.now() / 1000),
) => {
    try {
        const claimed = Number(claimedMilestones);
        let claimAmount = new BigNumber(0);
        let milestonesToClaim = 0;

        for (let i = claimed; i < scheduleSlots.length; i += 1) {
            const slot = scheduleSlots[i];
            const unlockAt = Number(slot?.unlockAt ?? slot?.unlockSec ?? 0);
            const rawAmount =
                slot?.amount != null ? slot.amount : slot?.amountWei ?? 0;
            const amount = new BigNumber(String(rawAmount));
            if (nowSec < unlockAt) break;
            claimAmount = claimAmount.plus(amount);
            milestonesToClaim += 1;
        }

        return {
            claimAmountWei: claimAmount.toFixed(0),
            milestonesToClaim,
        };
    } catch (_e) {
        return { claimAmountWei: '0', milestonesToClaim: 0 };
    }
};

/** Unclaimed escrow still held in the gateway contract for this locked payment. */

export const getRemainingEscrowWei = (paymentData) => {
    if (isLockedPaymentFinished(paymentData)) return '0';
    try {
        if (paymentData?.claimedAmount != null && paymentData?.totalAmount != null) {
            const remaining = new BigNumber(paymentData.totalAmount.toString()).minus(
                new BigNumber(paymentData.claimedAmount.toString()),
            );
            return remaining.isGreaterThan(0) ? remaining.toFixed(0) : '0';
        }

        const claimedWei = getClaimedAmountWei(
            paymentData.claimedMilestones,
            paymentData.totalAmount,
            paymentData.milestones,
        );
        const remaining = new BigNumber(paymentData.totalAmount.toString()).minus(
            claimedWei,
        );
        return remaining.isGreaterThan(0) ? remaining.toFixed(0) : '0';
    } catch (_e) {
        return '0';
    }
};
